import { render, staticRenderFns } from "./fileViewer.vue?vue&type=template&id=1356b71c&scoped=true"
import script from "./fileViewer.vue?vue&type=script&lang=js"
export * from "./fileViewer.vue?vue&type=script&lang=js"
import style0 from "./fileViewer.vue?vue&type=style&index=0&id=1356b71c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1356b71c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1356b71c')) {
      api.createRecord('1356b71c', component.options)
    } else {
      api.reload('1356b71c', component.options)
    }
    module.hot.accept("./fileViewer.vue?vue&type=template&id=1356b71c&scoped=true", function () {
      api.rerender('1356b71c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/fileViewer.vue"
export default component.exports